import { getDeveloperMode } from '@wix/wix-data-client-common'
import type { PageRef, PagesPanelTabType } from '@wix/editor-platform-sdk-types'
import type { EditorSDK, Logger } from '@wix/wix-data-client-common-standalone'

const pagesPanelFriendlyOrigins = [
  'dynamicPagesIntro',
  'pagesPanel',
  'addPagePanel',
  'duplicate_page_suggest_preset_modal',
  'duplicate_page_suggest_convert_to_dp',
  'quickActionsMenu',
  'panel/pages',
]

export const openPagesPanelIfNeeded = async ({
  editorSdkProxy,
  origin,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  origin: string
  pageRef: PageRef
}) => {
  const isDeveloperModeEnabled = await getDeveloperMode(editorSdkProxy)

  if (!isDeveloperModeEnabled || pagesPanelFriendlyOrigins.includes(origin)) {
    await editorSdkProxy.editor.openPagesPanel({
      pageRef,
      // Keep "Page Settings" panel closed for now
      initialSettingsTabType: undefined as unknown as PagesPanelTabType,
    }) // opens pages panel and navigates to page
  } else {
    await editorSdkProxy.pages.navigateTo({ pageRef })
  }
}

export const getProgressBar = ({
  editorSdkProxy,
  logger,
  totalSteps,
  title,
}: {
  editorSdkProxy: EditorSDK
  logger: Logger
  totalSteps: number
  title: string
}) => {
  let currentStep = 0
  let lastStepTitle: string | undefined = undefined

  return {
    open: () =>
      editorSdkProxy.editor.openProgressBar({
        title,
        totalSteps,
      }),
    close: () => editorSdkProxy.editor.closeProgressBar({}),
    update: async ({ stepTitle }: { stepTitle?: string } = {}) => {
      const stepTitleToUse =
        currentStep === totalSteps ? lastStepTitle : stepTitle

      logger.breadcrumb({
        category: title,
        message: `Running "${stepTitleToUse}" step`,
      })

      await editorSdkProxy.editor.updateProgressBar({
        currentStep,
        stepTitle: stepTitleToUse,
      })

      currentStep++
      lastStepTitle = stepTitle
    },
  }
}

export type ProgressBar = ReturnType<typeof getProgressBar>
